<template>
	<div class="signature-container">
		<div class="signature-header">
			<label>{{ title }}</label>
			<button
				v-if="file == null && disabled === false"
				type="button"
				@click="$refs.signaturePad.undoSignature()"
			>
				<RotateCcwIcon/>
			</button>
		</div>
		<VueSignaturePad
			v-if="file == null"
			:options="{backgroundColor: 'rgb(255,255,255)'}"
			class="signature-input"
			height="200px"
			ref="signaturePad"
		/>
		<img
			v-else
			class="signature-image"
			:src="'/files/getById?height=1080&width=1080&file_id=' + file.id"
			:alt="file.file_name"
		>
	</div>
</template>

<script>
import {QueuedFile} from "@/common/queued-file";
import LoadingIndicator from "@/components/LoadingIndicator";
import {RotateCcwIcon} from "vue-feather-icons";
import {mapActions, mapGetters} from "vuex";

export default {
	components: {
		LoadingIndicator,
		RotateCcwIcon
	},
	data() {
		return {
			pendingFile: null,
			file: null,
			allowedToUpload: false,
			fileName: ""
		};
	},

	props: {
		title: {
			type: String,
			default: ""
		},
		type: {
			type: String,
			default: ""
		},
		companyId: {
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		},
		startUpload: {
			type: Boolean,
			default: false
		},
		value: {
			type: String | Number,
			default: ""
		}
	},

	created() {
	},
	mounted() {
		this.getFiles();
		this.allowedToUpload = this.allowedTo("files/add");
		if (this.disabled) {
			this.$refs.signaturePad.lockSignaturePad();
		}
	},
	watch: {
		startUpload: function (newValue) {
			if (newValue) {
				this.uploadFiles();
			}
		}
	},

	methods: {
		...mapActions({
			fetchFiles: "files/fetchFiles"
		}), ...mapGetters({
			allowedTo: "auth/allowedTo"
		}),

		getFiles() {
			this.fetchFiles({
				type: this.type,
				company_id: this.companyId
			}).then(response => {
				if (response.length > 0 && this.empty(this.value) === false) {
					this.file = response.find(file => file.id === this.value);
				}
			});
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		},

		uploadFiles() {
			return new Promise((resolve, reject) => {
				if (this.disabled) {
					resolve();
					return;
				}

				if (!this.$refs.hasOwnProperty("signaturePad") || this.$refs.signaturePad == null) {
					resolve();
					return;
				}
				const signature = this.$refs.signaturePad.saveSignature("image/jpeg", 0.7);
				if (signature.isEmpty === true) {
					resolve();
					return;
				}

				this.pendingFile = new QueuedFile(signature.data, this.type, this.companyId, () => {
				});
				this.pendingFile.upload().then(response => {
					this.fileName = this.pendingFile.file_name;
					this.pendingFile = null;
					this.fetchFiles({
						type: this.type,
						company_id: this.companyId
					}).then(response => {
						this.files = response;
						if (this.files.length > 0 && this.empty(this.value)) {
							const file = this.files.find(file => file.file_name === this.fileName.replaceAll(
								" ",
								"_"
							));
							if (file != null) {
								this.$emit("input", file.id);
							}
						}
						resolve();
					}).catch((error) => {
						reject(error);
					});
				}).catch((error) => {
					reject(error);
				});
			});
		}
	}
};
</script>

<style scoped lang="scss">

.signature-container {
	width: 100%;

	.signature-header {
		display: flex;
		justify-content: left;
		align-items: center;

		label {
			font-size: 1.2rem;
			font-weight: 500;
		}

		button {
			margin-left: 8px;
			border: 2px solid #e53935;
			color: #e53935;
			width: 64px;
			min-width: 64px;
			background: #ffffff;
			height: 36px;
			align-items: center;
			display: flex;
			justify-content: center;
			border-radius: 5px;
		}
	}

	.signature-input {
		margin-top: 8px;
		border: 2px solid #ced6dd;
		border-radius: 5px;
		box-sizing: content-box;
		background: #ffffff;
	}

	.signature-image {
		height: 200px;
		width: 100%;
		object-fit: contain;
		margin-top: 8px;
		border: 2px solid #ced6dd;
		border-radius: 5px;
		box-sizing: border-box;
	}
}

</style>
